"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Award, CircleCheck, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocalPartnerForFreshAir() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const certifications = [{
    title: "Auktoriserad redovisning",
    description: "Vi säkerställer att din ekonomi hanteras med högsta precision och enligt gällande regelverk.",
    icon: ShieldCheck
  }, {
    title: "Strategisk rådgivning",
    description: "Vi hjälper dig att tolka siffrorna och fatta beslut som driver din verksamhet framåt.",
    icon: Award
  }];
  return <section data-section-id="139289" id="din-partner-i-tillväxt" className="dark bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            {}
            <div className="absolute -inset-4 bg-accent/20 rounded-sm -z-10 transform rotate-2 scale-105 transition-transform duration-700 hover:rotate-1" />
            
            <div className="rounded-sm overflow-hidden shadow-md ring-1 ring-border/50 bg-card">
              <AspectRatio ratio={4 / 5} className="bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620476/img/ventilation_malmo_team_office.png" alt="Logik Ekonomi Sverige AB - Personlig redovisning och rådgivning" className="object-cover w-full h-full transition-transform duration-700 hover:scale-105" />
              </AspectRatio>
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 bg-card p-6 rounded-sm shadow-md ring-1 ring-border flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
              <div className="bg-primary/10 p-3 rounded-full text-primary">
                <Award className="size-8" />
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">Kvalitetsgaranti</p>
                <p className="text-lg font-bold text-foreground">10+ nöjda klienter</p>
              </div>
            </div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/20 text-secondary-foreground text-sm font-medium mb-6 w-fit">
              <span className="relative flex size-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full size-2 bg-primary"></span>
              </span>
              Logik i siffror, hjärta i mötet
            </div>

            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6 leading-tight">
              Din partner för hållbar tillväxt
            </h2>
            
            <h3 className="text-xl md:text-2xl font-serif text-muted-foreground mb-8 leading-relaxed italic">
              "Vi förenar logisk analys med mänskligt engagemang för att skapa de bästa förutsättningarna för ditt företag."
            </h3>

            <p className="text-foreground/80 text-lg leading-relaxed mb-10">
              Sedan starten har Logik Ekonomi Sverige AB arbetat för att avmystifiera ekonomi och göra den till ett verktyg för tillväxt. Som en mindre byrå erbjuder vi den flexibilitet och närhet som krävs för att verkligen förstå din verksamhet och dina visioner. Vi ser bortom siffrorna för att hitta möjligheterna.
            </p>

            <div className="space-y-6 mb-10">
              {certifications.map((cert, i) => <div key={i} data-index={i} className="flex items-start gap-4">
                  <div className="mt-1 bg-primary/10 p-2 rounded-lg text-primary shrink-0">
                    <cert.icon className="size-6" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-foreground mb-1">{cert.title}</h4>
                    <p className="text-muted-foreground">{cert.description}</p>
                  </div>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4 border-t border-border">
              <Button asChild size="lg" className="text-base h-12 px-8 bg-primary hover:bg-primary/90 text-primary-foreground">
                <Link to="/AboutUsPage">
                  Läs mer om oss
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="text-base h-12 px-8 border-border hover:bg-accent hover:text-accent-foreground">
                <Link to="/ContactPage">
                  Boka ett möte
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}